import { IconButton, styled } from '@mui/material';

export interface AttendanceExportButtonProps {
  primary?: boolean;
}

export const AttendanceExportButton = styled(IconButton)<AttendanceExportButtonProps>(
  ({ theme, primary }) => ({
    color: theme.palette.primary.main,
    borderRadius: theme.shape.borderRadiusSm,
    padding: theme.spacing(0.75, 1.5),
    gap: theme.spacing(0.75),

    ...(primary && {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
    }),

    '&:hover': {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
    },

    '&.Mui-disabled': {
      ...(primary && {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.common.grey,
      }),
    },
  }),
);
